import { useId } from "react";

export default function Checkbox({
	name,
	label,
	value,
	type = "checkbox",
	checked,
	onChange,
	required = false,
	className = "",
}: {
	name: string;
	label: string;
	value?: string;
	type?: "checkbox" | "radio";
	checked?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
	required?: boolean;
	className?: string;
}) {
	const id = useId();
	return (
		<span className={`${className} relative`}>
			<input
				id={id}
				name={name}
				value={value}
				tabIndex={0}
				type={type}
				role={type}
				data-checkmark="✔&#xfe0e;"
				aria-checked={checked}
				checked={checked}
				onChange={(e) => onChange?.(e)}
				required={required}
				className={`${type === "checkbox" ? "rounded-sm" : "rounded-full"} peer m-0 mr-2 inline-flex h-4 w-4 appearance-none items-center justify-center border border-solid border-primary-500 p-0 outline-none ring-1 ring-transparent ring-offset-1 transition-all before:text-[80%] before:text-white before:content-[attr(data-checkmark)] checked:bg-primary-500 focus-visible:ring-primary-500`}
			/>
			<label className="align-middle" htmlFor={id}>
				{label}
			</label>
		</span>
	);
}
